import { z } from "zod";
import { fulfilledQuantitySchema, idSchema } from "../primitives.js";

/**
 * qty_step is never applied to the actual delivered quantity.
 * Even if the order was in 0.5 lb steps, the scale reads 97.3 lb — that's the billing basis.
 */
export const finalizeRoundInput = z.object({
  lines: z
    .array(z.object({ commitmentId: idSchema, fulfilledQty: fulfilledQuantitySchema }))
    .min(1)
    .max(500),
});

export const finalizeDealInput = z.object({
  lines: z.array(z.object({ claimId: idSchema, fulfilledQty: fulfilledQuantitySchema })).min(1).max(500),
});

export type FinalizeRoundInput = z.infer<typeof finalizeRoundInput>;
export type FinalizeDealInput = z.infer<typeof finalizeDealInput>;
